const LIST_ID_STORE = "itemListId";

const setListId = (listId: string) => {
	try {
		window.sessionStorage.setItem(LIST_ID_STORE, listId);
	} catch (error) {
		console.error(error);
	}
};

const getListId = () => {
	let listId: string | null = null;
	try {
		listId = window.sessionStorage.getItem(LIST_ID_STORE);
	} catch (error) {
		console.error(error);
	}
	return listId;
};

const ITEM_LIST_STORE = "itemList";

type StoreItem = { id: `${number}`; listId: string };

const _getStoreFromLocalStorage = () => {
	let store: StoreItem[] = [];
	try {
		store = JSON.parse(window.localStorage.getItem(ITEM_LIST_STORE) ?? "[]");
	} catch (error) {
		console.error(error);
	}
	return store;
};

const _writeToLocalStorage = (store: StoreItem[]) => {
	try {
		const data = JSON.stringify(store);
		window.localStorage.setItem(ITEM_LIST_STORE, data);
	} catch (error) {
		console.error(error);
	}
};

const _saveItemInStore = (styleId: `${number}`, listId: string) => {
	const store = _getStoreFromLocalStorage();
	const data = { id: styleId, listId };
	const itemIndex = store.findIndex((item) => item.id === data.id);
	// add
	if (itemIndex === -1) {
		store.push(data);
	}
	// update
	else {
		store[itemIndex] = data;
	}

	_writeToLocalStorage(store);
};

const _removeItemsFromStore = (styleIds: string[]) => {
	const store = _getStoreFromLocalStorage();
	const newStore: StoreItem[] = [];
	store.forEach((item) => {
		if (!styleIds.includes(item.id)) newStore.push(item);
	});

	_writeToLocalStorage(newStore);
};

const setItem = (styleId: `${number}`, listId: string) => {
	_saveItemInStore(styleId, listId);
};

const getItems = () => {
	const store = _getStoreFromLocalStorage();
	return store;
};

const removeItems = (styleIds: string[]) => {
	_removeItemsFromStore(styleIds);
};

const clear = () => {
	window.localStorage.removeItem(ITEM_LIST_STORE);
};

const GA4ItemListService = {
	setListId,
	getListId,
	setItem,
	getItems,
	removeItems,
	clear,
};
export default GA4ItemListService;
